module.exports = __webpack_public_path__ + "static/discount-656bee332f47140d4b6cb4492ce6efd4.png";